module.exports = __webpack_public_path__ + "assets/img/t21.8ec42c71.png";